import api from "@/services/api.ts";

export const updateFreightData = async (cep, orderFormId, itemsCount) => {
  const { data } = await api.post("/freight", {
    cep: cep,
    orderFormId: orderFormId,
    itemsCount: itemsCount
  });
  return data;
};

export const getAddressByCep = async (cep) => {
  const { data } = await api.get(`/freight/cep/${cep}`);
  return data;
};
